import { useEffect, useState } from "react";
import { Direction, NavigationArrow } from "./navigation-arrow";

export interface ContainerNavigationArrowProps {
  id: string;
}

// Hook to track the percent a user has scrolled through a specific container
function useScrollPercent({ id }: ContainerNavigationArrowProps) {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const currentPosition = element.scrollTop;
      const innerHeight = element.clientHeight;
      const docHeight = element.scrollHeight;
      const scrollPercent = (100 * currentPosition) / (docHeight - innerHeight);
      setScroll(scrollPercent);
    };

    const element: HTMLElement = document.getElementById(id) as HTMLElement;

    element.addEventListener("scroll", onScroll);
    return () => {
      element.removeEventListener("scroll", onScroll);
    };
  }, []);
  return scroll;
}

export const ContainerNavigationArrow = (
  props: ContainerNavigationArrowProps,
) => {
  const scrollPercent = useScrollPercent(props);
  const element = document.getElementById(props.id) as HTMLElement;

  // Scroll down until we're very close to the bottom of the page
  const variant = scrollPercent < 99 ? Direction.Down : Direction.Up;
  // Scroll up or down, depending on the variant
  const scrollY = () =>
    variant === Direction.Down
      ? Math.min(
          element.scrollHeight,
          element.scrollTop + element.scrollHeight / 4,
        )
      : 0;

  const placement = {
    base: "4rem",
    md: "1rem",
  };

  return (
    <NavigationArrow
      variant={variant}
      // Scroll onClick
      onClick={() => {
        document.getElementById(props.id)?.scrollTo(0, scrollY());
      }}
      position="fixed"
      _focus={{
        outline: "none",
      }}
      _focusVisible={{
        boxShadow: "none",
      }}
      bottom={placement}
      right="1rem"
      colorScheme="blue"
      zIndex={3}
    />
  );
};
